<template>
  <v-card v-if="year" :title="`Year ${year.year}: Info`">
    <template v-slot:append>
      <v-icon icon="mdi-pencil" @click="isYearEdit = !isYearEdit">
        <v-tooltip activator="parent" location="end">Edit Year Info</v-tooltip>
      </v-icon>
    </template>

    <v-card-text>
      <YearViewComponent v-if="!isYearEdit" :year="year" />
      <YearEditComponent
        v-else
        :year="year"
        @year-edit-cancelled="isYearEdit = false"
        @year-edit-completed="isYearEdit = false" />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { IYearDTO } from '@/dtos';
import { ref, computed, watch } from 'vue';
import { useUpdateStatusStore } from '@/stores/modules';
import { SNACKSTATUS } from '@/stores/util';
import YearViewComponent from '@/components/years/YearViewComponent.vue';
import YearEditComponent from '@/components/years/YearEditComponent.vue';

const props = defineProps<{ year: IYearDTO }>();
const emit = defineEmits(['snack']);

const year = computed(() => props.year);
const isYearEdit = ref(false);
const statusStore = useUpdateStatusStore();

watch(
  () => statusStore.getStatus(`year-${year.value.id}`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) return;
    const key = `year-${year.value.id}`;
    emit('snack', 'Year', value, statusStore.getError(key));
  },
);
</script>
